<div class="search-compact" dataAttribute componentName="search-compact">
  <b2b-back-button hideLabel></b2b-back-button>
  <b2b-portal-search-bar class="search-bar" dataAttribute componentName="search-bar" />
</div>
